import { Button } from '@protoss/ui';
import './page-error-state.css';

interface Props {
  message: string;
  onRetry: () => void;
}

export function PageErrorState({ message, onRetry }: Props) {
  return (
    <div className="page-error-state">
      <span className="page-error-state__message">{message}</span>
      <Button size="sm" variant="secondary" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}
